import { useContext } from "react";
import { ScrollContext, type ScrollContextType } from "./ScrollContext";

export const useScroll = (): ScrollContextType => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useScroll must be used within a ScrollProvider");
  }
  return context;
};
